export const DATA_AUTOMATION_VALUE = "location-cell";
export const DATA_AUTOMATION_SINGLE_COUNTRY_VALUE = "single-country-cell";
export const DATA_AUTOMATION_COUNTRY_GROUP_VALUE = "country-group-cell";
export const DATA_AUTOMATION_REGION_VALUE = "region-cell";
